window.addEventListener('load', () => {
	const inputFields = document.querySelectorAll('.o-form input[type="text"], textarea');
	for (let i = 0; i < inputFields.length; i++) {
		const inputField = inputFields[i];

		const closestList = inputField.closest('li')
		if (closestList) {
			closestList.classList.add('input-wrapper')


			let hasValue = false
			const focus = false


			inputField.addEventListener('focus', function () {
				focus == true
				closestList.classList.add('has-value')
			});

			inputField.addEventListener('blur', function () {
				if (!hasValue) {
					closestList.classList.remove('has-value')
				}
			});

			inputField.addEventListener('input', function (event) {
				if (event.target.value == '' && focus == false) {
					closestList.classList.remove('has-value')
					hasValue = false
				} else {
					closestList.classList.add('has-value')
					hasValue = true
				}
			});
		}
	}
})



// WEBPACK FOOTER //
// ./js/modules/form/input.js